import { VaporPageStickable } from "@vapor/react-contrib-tax-compliance";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Stack, useTheme } from "@vapor/react-material";
import { useTranslation } from "react-i18next";

/**
 * A bootstrap dead end: the app has no data to start from. Three causes, which
 * look the same to the user — the workspace list failed, the current organization
 * has no workspace of its own, or the subscriptions fetch errored out with
 * nothing cached to fall back on.
 *
 * Note the tail of that third one: a failed refetch that still has data behind
 * it does NOT come here (see ViewWrapper). This is the "nothing to render at
 * all" screen, not the "something went wrong" screen.
 *
 * The name is deliberately generic: "workspace not available" would be false in
 * the third case, where the workspace is there and it's the fetch that failed.
 */
export const DataNotAvailable = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <VaporPageStickable>
            <Stack justifyContent="center" alignItems="center">
                <Typography
                    variant="h4"
                    color={theme.palette.primary.textTitleColor}
                >
                    {t("components.data_not_available.unavailable")}
                </Typography>
            </Stack>
        </VaporPageStickable>
    );
};
